import AuthTypes from './AuthTypes';

export const checkLogin = (payload) => ({
  type: AuthTypes.LOGIN_IN_PROGRESS,
  payload,
});

export const setLoginSuccess = (payload) => ({
  type: AuthTypes.LOGIN_IN_SUCCESS,
  payload,
});

export const setLoginError = (payload) => ({
  type: AuthTypes.LOGIN_IN_ERROR,
  payload,
});

export const getUserMenuInProgress = (payload) => ({
  type: AuthTypes.GET_USER_MENU_PROGRESS,
  payload,
});

export const getUserMenuInSuccess = (payload) => ({
  type: AuthTypes.GET_USER_MENU_SUCCESS,
  payload,
});

export const getUserMenuInError = (payload) => ({
  type: AuthTypes.GET_USER_MENU_ERROR,
  payload,
});

export const getUserMenuItemsInProgress = (payload) => ({
  type: AuthTypes.GET_USER_MENU_ITEMS_PROGRESS,
  payload,
});

export const getUserMenuItemsInSuccess = (payload) => ({
  type: AuthTypes.GET_USER_MENU_ITEMS_SUCCESS,
  payload,
});

export const getUserMenuItemsInError = (payload) => ({
  type: AuthTypes.GET_USER_MENU_ITEMS_ERROR,
  payload,
});

export const setSelectedCompany = (payload) => ({
  type: AuthTypes.SET_SELECTED_COMPANY,
  payload,
});

export const initiateLogout = () => ({
  type: AuthTypes.INITIATE_LOGOUT,
});

export const forgotPasswordInProgress = (payload) => ({
  type: AuthTypes.FORGOT_PASSWORD_PROGRESS,
  payload,
});

export const forgotPasswordInSuccess = (payload) => ({
  type: AuthTypes.FORGOT_PASSWORD_SUCCESS,
  payload,
});

export const forgotPasswordInError = (payload) => ({
  type: AuthTypes.FORGOT_PASSWORD_ERROR,
  payload,
});

export const resetForgotPassword = (payload) => ({
  type: AuthTypes.RESET_FORGOT_PASSWORD,
  payload,
});

export const userRegistrationInProgress = (payload) => ({
  type: AuthTypes.USER_REGISTRATION_PROGRESS,
  payload,
});

export const userRegistrationInSuccess = (payload) => ({
  type: AuthTypes.USER_REGISTRATION_SUCCESS,
  payload,
});

export const userRegistrationInError = (payload) => ({
  type: AuthTypes.USER_REGISTRATION_ERROR,
  payload,
});

export const resetUserRegistration = (payload) => ({
  type: AuthTypes.RESET_USER_REGISTRATION,
  payload,
});

export const getUserProfileInProgress = (payload) => ({
  type: AuthTypes.GET_USER_PROFILE_PROGRESS,
  payload,
});

export const getUserProfileInSuccess = (payload) => ({
  type: AuthTypes.GET_USER_PROFILE_SUCCESS,
  payload,
});

export const getUserProfileInError = (payload) => ({
  type: AuthTypes.GET_USER_PROFILE_ERROR,
  payload,
});

export const userProfileUpdateInProgress = (payload) => ({
  type: AuthTypes.USER_PROFILE_UPDATE_PROGRESS,
  payload,
});

export const userProfileUpdateInSuccess = (payload) => ({
  type: AuthTypes.USER_PROFILE_UPDATE_SUCCESS,
  payload,
});

export const userProfileUpdateInError = (payload) => ({
  type: AuthTypes.USER_PROFILE_UPDATE_ERROR,
  payload,
});

export const updateUserPasswordInProgress = (payload) => ({
  type: AuthTypes.UPDATE_USER_PASSWORD_PROGRESS,
  payload,
});

export const updateUserPasswordInSuccess = (payload) => ({
  type: AuthTypes.UPDATE_USER_PASSWORD_SUCCESS,
  payload,
});

export const updateUserPasswordInError = (payload) => ({
  type: AuthTypes.UPDATE_USER_PASSWORD_ERROR,
  payload,
});

export const updateUserPreferenceInProgress = (payload) => ({
  type: AuthTypes.UPDATE_USER_PREFERENCE_PROGRESS,
  payload,
});
export const updateUserPreferenceInSuccess = (payload) => ({
  type: AuthTypes.UPDATE_USER_PREFERENCE_SUCCESS,
  payload,
});
export const updateUserPreferenceInError = (payload) => ({
  type: AuthTypes.UPDATE_USER_PREFERENCE_ERROR,
  payload,
});

export const getUserPreferenceInProgress = (payload) => ({
  type: AuthTypes.GET_USER_PREFERENCE_PROGRESS,
  payload,
});
export const getUserPreferenceInSuccess = (payload) => ({
  type: AuthTypes.GET_USER_PREFERENCE_SUCCESS,
  payload,
});
export const getUserPreferenceInError = (payload) => ({
  type: AuthTypes.GET_USER_PREFERENCE_ERROR,
  payload,
});

export const changeCompanyInProgress = (payload) => ({
  type: AuthTypes.CHANGE_COMPANY_IN_PROGRESS,
  payload,
});

export const changeCompanyInSuccess = (payload) => ({
  type: AuthTypes.CHANGE_COMPANY_IN_SUCCESS,
  payload,
});

export const changeCompanyInFail = (payload) => ({
  type: AuthTypes.CHANGE_COMPANY_IN_FAIL,
  payload,
});

export const approveRejectShipmentInProgress = (payload) => ({
  type: AuthTypes.APPROVE_REJECT_SHIPMENT_IN_PROGRESS,
  payload,
});
export const approveRejectShipmentInSuccess = (payload) => ({
  type: AuthTypes.APPROVE_REJECT_SHIPMENT_IN_SUCCESS,
  payload,
});
export const approveRejectShipmentInFail = (payload) => ({
  type: AuthTypes.APPROVE_REJECT_SHIPMENT_IN_FAIL,
  payload,
});

export const updateUserProfileImageInProgress = (payload) => ({
  type: AuthTypes.UPDATE_USER_PROFILE_IMAGE_PROGRESS,
  payload,
});
export const updateUserProfileImageInSuccess = (payload) => ({
  type: AuthTypes.UPDATE_USER_PROFILE_IMAGE_SUCCESS,
  payload,
});
export const updateUserProfileImageInError = (payload) => ({
  type: AuthTypes.UPDATE_USER_PROFILE_IMAGE_ERROR,
  payload,
});
